import { I18nValues } from './types';

export const localI18nPt: I18nValues = {
	'general.genericError.title': '<b>Pedimos desculpa</b>, mas neste momento não é possível satisfazer o seu pedido.',
	'general.genericError.subtitle': 'Por favor tente mais tarde',
	'general.back': 'Voltar',
};
